/**
 * Flattens a PNG logo onto a white canvas for jsPDF.
 * Transparent pixels otherwise render as black in production PDF builds.
 */
const logoCache = new Map();

export function getPdfLogoDataUrl(imageSrc) {
  if (!imageSrc) {
    return Promise.reject(new Error("Logo image source is required"));
  }

  const cached = logoCache.get(imageSrc);
  if (cached) {
    return cached;
  }

  const promise = new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const width = img.naturalWidth || img.width;
      const height = img.naturalHeight || img.height;
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, width, height);
      ctx.drawImage(img, 0, 0, width, height);
      resolve(canvas.toDataURL("image/png"));
    };
    img.onerror = () => reject(new Error("Failed to load logo for PDF export"));
    img.src = imageSrc;
  });

  logoCache.set(imageSrc, promise);
  return promise;
}

/**
 * Adds company logo to a jsPDF document without transparent-background artifacts.
 */
export async function addPdfLogo(doc, imageSrc, x, y, width, height) {
  const dataUrl = await getPdfLogoDataUrl(imageSrc);
  doc.addImage(dataUrl, "PNG", x, y, width, height);
}
